module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/jetSkiFeatured3.webp";